
export const name = "documents-public-ui";
export const version = "1.32558";
